import { render, staticRenderFns } from "./DetallesView.vue?vue&type=template&id=ba8b192e"
import script from "./DetallesView.vue?vue&type=script&lang=js"
export * from "./DetallesView.vue?vue&type=script&lang=js"
import style0 from "./DetallesView.vue?vue&type=style&index=0&id=ba8b192e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports